// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

const xDefaultRules = {
    text: "max:100",
    password: "min:3",
    email: "email|min:5|max:200",
    phone: "phone|min:10|max:14",
    qty: "number|min:0|max:9999",
    companyName: "min:1|max:40",
    address: "min:1|max:40",
    city: "min:1|max:30",
    postalCode: "postalCode:US|min:5|max:10",
    poNumber: "max:10",
    notes: "max:500",
    fullName: "min:2|max:50",
    firstName: "min:2|max:25",
    lastName: "min:2|max:25",
    url: "max:2048",
    userName: "min:2|max:60",
    requiredCheckBox: "boolean|requiredCheckBox",
};

const xMapTypeToDomType: { [key: string]: string } = {
    email: "email",
    password: "password",
};

export default xDefaultRules;

export { xMapTypeToDomType };
